import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseAdmin: null,
  franchiseAdmins: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseAdminReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEADMIN_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEADMIN_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEADMIN_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default franchiseAdminReducer;
